import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

// Shield "Privacy & Terms" link anchored to the bottom of its page.
// ctx/slug tailor the themed legal page it opens; iconOnly hides the words
// (used on firm-branded pages where we only show a small shield).
export default function LegalLink({ tone = "gold", className = "", ctx = null, slug = null, iconOnly = false, inline = false }) {
  const color = tone === "neon"
    ? "text-cyan-300/70 hover:text-cyan-200"
    : tone === "blue"
      ? "text-sky-300/85 hover:text-sky-200"
      : tone === "muted"
      ? "text-white/45 hover:text-white/80"
      : "text-[#cbb26a]/85 hover:text-[#e4d29a]";
  const params = new URLSearchParams();
  if (ctx) params.set("ctx", ctx);
  if (slug) params.set("slug", slug);
  const to = "/legal" + (params.toString() ? `?${params.toString()}` : "");
  const pos = inline ? "relative" : "absolute bottom-4 left-1/2 -translate-x-1/2";
  return (
    <Link
      to={to}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="legal-shield-link"
      title="Privacy Policy & Terms of Use"
      className={`${pos} z-20 inline-flex items-center gap-1.5 text-[12px] tracking-wide transition-colors duration-200 ${color} ${className}`}
    >
      <ShieldCheck size={14} />
      {!iconOnly && <span className="hidden sm:inline">Privacy &amp; Terms</span>}
    </Link>
  );
}
